import { call, put, takeLatest } from "redux-saga/effects";
import { danhMucApi } from "../../../api/category/danhMucApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eHeActionTypeIds, IHeActions } from "../../action-types/category/IHeActionType";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.category.he;

export function* heSaga(): any {
    yield takeLatest(eHeActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IHeActions): any {
    const res: IBaseRespone = yield call(danhMucApi.SelectAllHe)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}